// extracted by mini-css-extract-plugin
export default {"metricUnitsDropdown":"metric-units-dropdown__KcNpxeqy"};